import React from 'react'
import styled from '@emotion/styled'
// import ReactJson from 'react-json-view'
import { Helmet } from 'react-helmet-async'
import {
  Add as AddIcon,
  Archive as ArchiveIcon,
  FilterList as FilterListIcon,
  RemoveRedEye as RemoveRedEyeIcon,
} from '@mui/icons-material'

import {
  CardContent,
  Button,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Divider as MuiDivider,
  Typography,
} from '@mui/material'

import { spacing } from '@mui/system'

const Card = styled(MuiCard)(spacing)

const Divider = styled(MuiDivider)(spacing)

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing)

function EmptyCard() {
  return (
    <Card mb={6}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Empty card
        </Typography>
        <Typography variant="body2" gutterBottom>
          Empty card
        </Typography>
      </CardContent>
    </Card>
  )
}

function KitchenOrder() {
  // const { loading, error, data = [] } = kotFetch(
  //   `${APIPATH}hotel_billing/kot/order/item?id=023f6b16-3429-49c0-b794-0f5892902fff`
  // )
  if (error) return <p>Error!</p>
  if (loading) return <p>Loading...</p>
  return <>
    <Helmet title="Kitchen Order" />
    <Grid justifyContent="space-between" container spacing={24}>
      <Grid item>
        <Typography variant="h3" gutterBottom display="inline">
          Kitchen Order
        </Typography>
      </Grid>
      <Grid item>
        <div>
          <Button variant="contained" color="primary">
            <AddIcon />
            New Order
          </Button>
        </div>
      </Grid>
    </Grid>
    <Divider my={6} />

    <Grid container spacing={6}>
      <Grid item xs={3}>
        <EmptyCard />
      </Grid>
    </Grid>
    <div>
      <ReactJson src={data} />
    </div>
  </>;
}

export default KitchenOrder
